import { ITraineeDashboardRes } from "../models/dashboard/trainee-dashboard";
import { IUserBio, IUserBioRes } from "../models/userbio.model";
import { IUserProfileRes } from "../models/userprofile.model";
import getService from "./getService";
import postService from "./postService";
// import postService from './postService';

const CONFIG_API_URL =
  process.env.REACT_APP_API_BASE_URL || "http://20.126.75.78/naptin/api/v1/";

const USERBIO = "user";
const USERPROFILE = "users/";
const USERWALLET = "user/";
const APPROVEUSER = "users/";
const dashboard = "trainees/dashboard";
const EDITUSER = "users/";

class UserService {
  async getUserBio() {
    const response = await getService.get(`${CONFIG_API_URL}${USERBIO}`);
    const res: IUserBioRes = response.data;
    return res;
  }
  async getUserByCategory(url: string) {
    const response = await getService.get(
      `${CONFIG_API_URL}admin/users-by-category${url}`
    );
    const res: any = response.data;
    return res;
  }
  async getTraineeDashboard() {
    const response = await getService.get(`${CONFIG_API_URL}${dashboard}`);
    const res: ITraineeDashboardRes = response.data;
    return res;
  }

  async getUserProfile(uuid: string) {
    const response = await getService.get(
      `${CONFIG_API_URL}${USERPROFILE}${uuid}`
    );
    const res: IUserProfileRes = response.data;
    return res;
  }
  async getUserWallet(uuid: string) {
    const response = await getService.get(
      `${CONFIG_API_URL}${USERWALLET}${uuid}/wallet`
    );
    const res: any = response.data;
    return res;
  }
  async getUserWalletHistory(uuid: string) {
    const response = await getService.get(
      `${CONFIG_API_URL}${USERWALLET}${uuid}/wallet-history`
    );
    const res: any = response.data;
    return res;
  }
  async getUserNotifications(uuid: string) {
    const response = await getService.get(
      `${CONFIG_API_URL}${USERWALLET}${uuid}/notifications`
    );
    const res: any = response.data;
    return res;
  }
  async fundUserWallet(uuid: string, data: any) {
    const response = await postService.post(
      `${CONFIG_API_URL}${USERWALLET}${uuid}/wallet`,
      data
    );
    const res: any = response.data;

    return res;
  }
  async approvalStatus(uuid: string, data: any) {
    const response = await postService.post(
      `${CONFIG_API_URL}${APPROVEUSER}${uuid}/approval-status`,
      data
    );
    const res: any = response.data;

    return res;
  }
  async editUser(uuid: string | undefined, data: any) {
    const response = await postService.post(
      `${CONFIG_API_URL}${EDITUSER}${uuid}/edit`,
      data
    );
    const res: any = response.data;

    return res;
  }
}

export default new UserService();
